// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bg-dark: #080808;
  --bg-alt: #535353;
  --green: #3e7742;
  --brown: #431a10;
  --beige: #e1b89f;
  --text-lt: #f9f9f9;
  --text-dk: #303030;
  --yellow: #d4a017; /* For highlights or Call to Action */
  --red: #7c1c1c; /* For vibrancy (important elements) */
  --teal: #2e7d6c;
}

body {
    font-family: Arial, sans-serif;
    margin: 0;
    padding: 0;
}
  
header {
    background-color: var(--beige);
    color: var(--text-lt);
    text-align: center;
    border-bottom: 2px solid var(--brown);
}
  
nav button {
    background: var(--brown);
    border: none;
    color: var(--text-lt);
    cursor: pointer;
    font-size: 1rem;
    font-weight: bold;
    margin: 0 0.5rem;
    padding: 10px 20px 10px;
    border-top-left-radius: 23px;
    border-top-right-radius: 23px;
}
  
nav button:hover {
    color: var(--green);
}
  
#content {
    padding: 2rem;
    text-align: center;
    background-color: var(--bg-alt);
}
  
.logo {
    width: 250px; /* Adjust size as needed */
    height: auto;
    margin: 1rem auto;
}
  
h1, h2 {
    color: var(--text-lt);
}
  
p {
    color: var(--text-lt);
    font-size: 1.2rem;
}

.home, .menu, .about {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  border: 2px solid var(--teal);
  padding: 20px;
  width: 480px;
  margin: 0 auto 4rem;
  text-shadow: 0 2px 3px rgba(0, 0, 0, 0.4);
}

.menu-category {
  align-self: flex-start;
  margin-right: 275px;
}

.menu-item {
  font-weight: bold;
  align-self: flex-start;
  color: var(--text-lt);  
}

.item-description {
  color: var(--text-lt);
  font-size: 1rem;
  margin: 4px 0 1rem;
  width: 420px;
}

footer {
  background-color: var(--bg-dark); /* Alternative dark background */
  color: var(--text-lt); /* Light text for dark background */
  padding: 20px 0;
  text-align: center;
  font-family: 'Arial', sans-serif;
  border-top: 2px solid var(--brown); /* Brown border for separation */
}

footer p {
  margin: 0;
  padding: 5px 0;
  font-size: 14px;
}

.social-links {
  margin-top: 10px;
}

.social-links a {
  color: var(--green); /* Primary green for icons */
  font-size: 20px;
  margin: 0 10px;
  text-decoration: none;
  transition: color 0.3s ease;
}

.social-links a:hover {
  color: var(--golden-yellow); /* Golden yellow on hover */
}

.social-links a:focus {
  outline: 2px solid var(--beige); /* Beige outline for accessibility */
  outline-offset: 2px;
}`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB,EAAE,qCAAqC;EACxD,cAAc,EAAE,sCAAsC;EACtD,eAAe;AACjB;;AAEA;IACI,8BAA8B;IAC9B,SAAS;IACT,UAAU;AACd;;AAEA;IACI,8BAA8B;IAC9B,qBAAqB;IACrB,kBAAkB;IAClB,qCAAqC;AACzC;;AAEA;IACI,wBAAwB;IACxB,YAAY;IACZ,qBAAqB;IACrB,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;IACvB,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,+BAA+B;AACnC;;AAEA;IACI,YAAY,EAAE,0BAA0B;IACxC,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,6BAA6B;EAC7B,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,gCAAgC,EAAE,gCAAgC;EAClE,qBAAqB,EAAE,mCAAmC;EAC1D,eAAe;EACf,kBAAkB;EAClB,gCAAgC;EAChC,kCAAkC,EAAE,gCAAgC;AACtE;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB,EAAE,4BAA4B;EACjD,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B,EAAE,2BAA2B;AAC1D;;AAEA;EACE,+BAA+B,EAAE,oCAAoC;EACrE,mBAAmB;AACrB","sourcesContent":[":root {\n  --bg-dark: #080808;\n  --bg-alt: #535353;\n  --green: #3e7742;\n  --brown: #431a10;\n  --beige: #e1b89f;\n  --text-lt: #f9f9f9;\n  --text-dk: #303030;\n  --yellow: #d4a017; /* For highlights or Call to Action */\n  --red: #7c1c1c; /* For vibrancy (important elements) */\n  --teal: #2e7d6c;\n}\n\nbody {\n    font-family: Arial, sans-serif;\n    margin: 0;\n    padding: 0;\n}\n  \nheader {\n    background-color: var(--beige);\n    color: var(--text-lt);\n    text-align: center;\n    border-bottom: 2px solid var(--brown);\n}\n  \nnav button {\n    background: var(--brown);\n    border: none;\n    color: var(--text-lt);\n    cursor: pointer;\n    font-size: 1rem;\n    font-weight: bold;\n    margin: 0 0.5rem;\n    padding: 10px 20px 10px;\n    border-top-left-radius: 23px;\n    border-top-right-radius: 23px;\n}\n  \nnav button:hover {\n    color: var(--green);\n}\n  \n#content {\n    padding: 2rem;\n    text-align: center;\n    background-color: var(--bg-alt);\n}\n  \n.logo {\n    width: 250px; /* Adjust size as needed */\n    height: auto;\n    margin: 1rem auto;\n}\n  \nh1, h2 {\n    color: var(--text-lt);\n}\n  \np {\n    color: var(--text-lt);\n    font-size: 1.2rem;\n}\n\n.home, .menu, .about {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  border: 2px solid var(--teal);\n  padding: 20px;\n  width: 480px;\n  margin: 0 auto 4rem;\n  text-shadow: 0 2px 3px rgba(0, 0, 0, 0.4);\n}\n\n.menu-category {\n  align-self: flex-start;\n  margin-right: 275px;\n}\n\n.menu-item {\n  font-weight: bold;\n  align-self: flex-start;\n  color: var(--text-lt);  \n}\n\n.item-description {\n  color: var(--text-lt);\n  font-size: 1rem;\n  margin: 4px 0 1rem;\n  width: 420px;\n}\n\nfooter {\n  background-color: var(--bg-dark); /* Alternative dark background */\n  color: var(--text-lt); /* Light text for dark background */\n  padding: 20px 0;\n  text-align: center;\n  font-family: 'Arial', sans-serif;\n  border-top: 2px solid var(--brown); /* Brown border for separation */\n}\n\nfooter p {\n  margin: 0;\n  padding: 5px 0;\n  font-size: 14px;\n}\n\n.social-links {\n  margin-top: 10px;\n}\n\n.social-links a {\n  color: var(--green); /* Primary green for icons */\n  font-size: 20px;\n  margin: 0 10px;\n  text-decoration: none;\n  transition: color 0.3s ease;\n}\n\n.social-links a:hover {\n  color: var(--golden-yellow); /* Golden yellow on hover */\n}\n\n.social-links a:focus {\n  outline: 2px solid var(--beige); /* Beige outline for accessibility */\n  outline-offset: 2px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
